import { createContext, useContext } from "react";

import type { Table, TableCombination } from "~/providers/table-provider";

interface TableContext {
  tables: Table[];
  tableCombinations: TableCombination[];
}

export const TableContext = createContext<TableContext | undefined>(undefined);

export const useTable = () => {
  const context = useContext(TableContext);

  if (!context) {
    throw new Error("useTable must be used within a TableProvider");
  }
  return context;
};
